// src/state/store.ts
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";

import rootSaga from "../rootSaga";
import { rootReducer } from "./Reducers/rootReducer";

const logger = createLogger();
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  // middleware: [sagaMiddleware, logger],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([sagaMiddleware, logger]),
});

sagaMiddleware.run(rootSaga);

export default store;
